import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsCardsComponent } from './abs-cards.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AbsCardsComponent],
  exports: [AbsCardsComponent],
})
export class AbsCardsModule { }
